"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClosedComplaints = function ClosedComplaints(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 100 125", className: "custom-icon" }, props),
    _react2.default.createElement("path", { d: "M96.4,11h-3.7h-4.5H46.4h-8.1h-0.1c-1.6,0-3,1-3.5,2h0l-3.4,12l0,0H18.9h-4.8h-3.3c-2,0-3.8,1.6-3.8,3.6v3.6v1.1v20.3V89  h85.7h7.3V14.4C100,12.4,98.4,11,96.4,11z M93,25H38.6l2-7h5.8h41.8H93V25z" })
  );
};

exports.default = ClosedComplaints;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/closed-complaints.js
// module id = ../lib/egov-ui-kit/custom-icons/closed-complaints.js
// module chunks = 504